export default class TableLoadingRow {
    constructor() {}
}

window.vao = window.vao || {};
window.vao.components = window.vao.components || {};
window.vao.components.TableLoadingRow = TableLoadingRow;
